/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { UserPreferenceType } from '@jira/global-pages__dashboard-user-preference/src/types.tsx';
import type { GadgetDefinition } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import type { CustomReportGadgetData } from './common/types.tsx';
import { LazyCustomReportGadgetEdit } from './ui/edit/async.tsx';
import { LazyCustomReportGadgetView, preload } from './ui/view/async.tsx';
import getInitialState from './utils/get-initial-state.tsx';

const CUSTOM_REPORT_DEFINITION: GadgetDefinition<
	CustomReportGadgetData,
	CustomReportGadgetData,
	UserPreferenceType[]
> = {
	componentView: LazyCustomReportGadgetView,
	componentEdit: LazyCustomReportGadgetEdit,
	getInitialState,
	preload,
};

export default CUSTOM_REPORT_DEFINITION;
